/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type { Signature as ForcProviderSignature } from "parog-web/components/forc/provider";

interface Signature {
  Args: {
    form?: ForcProviderSignature["Blocks"]["content"][0];
  };
}

import Component from "@glimmer/component";

export default class FileUploadedEditionFormContentComponent extends Component<Signature> {
  static titleMaximumChars = 30;
}
